import { GridColDef } from "@mui/x-data-grid-pro";
import { Studio } from "entities/studios/types";
import DropdownList from "shared/components/DropdownList";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { formatUpdatedAt } from "shared/utils/formatUpdatedAt";

export const gamesStudiosColumns = (
  studioDetailsDrawer: DrawerHookResult<Studio>,
): GridColDef[] => {
  return [
    {
      field: "id",
      headerName: "ID",
      editable: false,
      flex: 1,
      sortable: false,
    },
    {
      field: "name",
      headerName: "Name",
      editable: false,
      flex: 1,
    },
    {
      field: "productsCount",
      headerName: "Product",
      editable: false,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      editable: false,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => formatUpdatedAt(params.value),
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      editable: false,
      align: "right",
      headerAlign: "right",
      flex: 0.5,
      renderCell: (params) => (
        <DropdownList
          items={[
            {
              title: "Edit",
              onClick: () => {
                studioDetailsDrawer.openDrawer(params.row);
              },
            },
          ]}
        />
      ),
    },
  ];
};
